
import { getClientCommonMessage } from '@/utils/nativeFn'
import { compareVersion } from "@/utils/compareVersion";
import AioConfirm from "@/components/Aio/AioConfirm.vue";
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
export default {
  name: 'BeforeUpload',
  props: {
    parentInfo:  {
      type: Object,
      default: () => ({}),
    },
    reportDataMap: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['callUploadAction',"openNoteStrategy"],
  components: {
    AioConfirm,
  },
  setup(props, { emit }) {
    const $xesLog = inject("$xesLog") as any; // 埋点
    let versionName = ref(0)
    const confirmInfo = reactive({})
    const confirmVisible = ref(false)
    const callUploadAction = () => {
      $xesLog.track('notes_upload_button_click', {
        ...props.reportDataMap,
        event_name:'上传笔记按钮点击',
        event_type: 'click',
        button_status:1,
        button_location:'知识卡片详情-待上传',
      })
      getClientCommonMessage({}, (res) => {
          versionName.value = res.service_version_name
          console.log(compareVersion(versionName.value + '',"1.11.0"),'compareVersion')
          if(compareVersion(versionName.value + '',"1.11.0") == -1){
            console.log('不支持卡牌')
            Object.assign(confirmInfo, {
                title: 'app升级提示',
                titleArr:['本版本暂不支持该题型，请先升级～','方式1: 应用商店搜索最新版本更新','方式2: app内点击【我的】->【关于我们】->【当前版本】更新'],
                confirmText: '确定',
                doConfirm,
            })
            confirmVisible.value = true
          }else{

            if(localStorage.getItem('strategyFirstShow') !== '1'){
              emit('openNoteStrategy')
            }else{
              emit('callUploadAction')
            }
          }
      })
    }
    const parentInfo = computed(() => {
      return props.parentInfo;
    });
    const openNoteStrategy = () => {
      console.log('----')
      emit('openNoteStrategy')
    }
    const doConfirm = () => {
        confirmVisible.value = false
    }
    return {
      callUploadAction,
      openNoteStrategy,
      confirmVisible,
      confirmInfo
    };
  },
};
